
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-syllabus",
      function () {
        return require("private-next-pages/upsc-syllabus/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-syllabus"])
      });
    }
  